import get from 'lodash/get';
import { getPasswordValidationMessage } from '../../../utils/util.password.js';

/**
 * Creates a new AuthPasswordSaveController.
 * @class
 */
class AuthPasswordSaveController {
    constructor($log, $ngRedux, $state, RecoveryService, ResponseStatusService) {
        this.$log = $log;
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.RecoveryService = RecoveryService;
        this.ResponseStatusService = ResponseStatusService;
    }

    $onInit() {
        this.$log.debug('PasswordSave::init');
        this.initHeadline();
        this.password = null;
        this.passwordVerify = null;
        this.passwordRegex = this.passwordPolicy.regex;

        if (this.$state.params.message) {
            this.headlineClass = 'md-headline-error';
            this.headline = this.$state.params.message;
        }

        if (this.passwordPolicy.status) {
            const responseStatus = this.ResponseStatusService.find(this.passwordPolicy.status);
            this.$state.transitionTo('recovery.passwordReset', {message: get(responseStatus, 'msg', 'System Error!')});
        }
    }

    validatePassword(field) {
        if (!this.password || !this.passwordRegex) {
            field.$setValidity('passwordPattern', true);
            return;
        }

        field.$setValidity(
            'passwordPattern',
            new RegExp(this.passwordRegex).test(this.password)
        );
    }

    getPasswordValidationMessage() {
        return getPasswordValidationMessage(
            this.password,
            this.passwordRegex
        );
    }

    savePassword() {
        this.initHeadline();
        if (this.recoveryForm.$valid && this.password === this.passwordVerify) {
            this.$ngRedux.dispatch({type: 'LOADING_START'});
            this.RecoveryService.resetPasswordExec(this.password).then(() => {
                this.$ngRedux.dispatch({type: 'LOADING_END'});
                this.$state.transitionTo('login.auth', {message: 'Your password has been changed successfully. Please Login.'});
            }, ({ data }) => {
                this.$ngRedux.dispatch({type: 'LOADING_END'});
                this.headlineClass = 'md-headline-error';

                if (data.status === 291) {
                    this.headline = 'This password has been already used before. Please try with new password.';
                } else {
                    this.headline = 'System Error!';
                }
            });
        } else if (this.password !== this.passwordVerify) {
            this.headlineClass = 'md-headline-error';
            this.headline = 'Passwords do not match!';
        }
    }

    initHeadline() {
        this.headlineClass = 'md-headline';
        this.headline = this.$state.current.params.headline;
    }
}

AuthPasswordSaveController.$inject = ['$log', '$ngRedux', '$state', 'RecoveryService', 'ResponseStatusService'];

export const authPasswordSave = {
    bindings: {
        passwordPolicy: '<'
    },
    controller: AuthPasswordSaveController,
    template: require('./auth-password-save.html')
};